import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { patchDocumentArchive } from '../requests';
import type { PatchDocumentArchiveRequestType } from '../types';

export const usePatchDocumentArchive = () => {
  const queryClient = useQueryClient();

  const onSuccess = async (_: any, { documentId }: any) => {
    const queries = queryClient.getQueriesData({});

    // refetch all documents queries
    queries.forEach((query: any) => {
      if (query[0][0] === API_QUERY_KEYS.documents) {
        queryClient.refetchQueries(query[0]);
      }
    });

    queryClient.setQueryData(
      [API_QUERY_KEYS.document, { documentId }],
      (oldData: any) => ({
        ...oldData,
        archived: true,
      }),
    );
  };

  return useMutation({
    mutationFn: (data: PatchDocumentArchiveRequestType) =>
      patchDocumentArchive(data),
    onSuccess,
  });
};
